// extracted by mini-css-extract-plugin
export default {"cshadow":"Sidebar_cshadow__J3ENZ"};